import React, { useState, useEffect } from 'react';
import YouTube from 'react-youtube';

const YouTubePreview = ({ videoUrl }) => {
  const [videoId, setVideoId] = useState('');

  useEffect(() => {
    // Extract the video ID from the URL
    let videoId = String(videoUrl || '').split('v=')[1];

    if (!videoId) {
      const match = String(videoUrl || '').match(/(?:youtu\.be\/)([^?\n]+)/);
      videoId = match ? match[1] : null;

    }

    // Link que casa no detector mas não tem "v=" nem "youtu.be/" (ex.: /embed/): sem prévia,
    // em vez de quebrar a conversa inteira com um erro de null.
    if (!videoId) {
      setVideoId('');
      return;
    }

    let ampersandPosition = videoId.indexOf('&');

    if (ampersandPosition != -1) {
      videoId = videoId.substring(0, ampersandPosition);
    }
    
    setVideoId(videoId);
  }, [videoUrl]);

  const opts = {
    height: '300',
    width: '100%',
  };

  return (
    <div style={{ margin: '0 0 4px -3px', lineHeight: 0 }}>
      {videoId && <YouTube videoId={videoId} opts={opts} style={{ borderRadius: 6, overflow: 'hidden' }} />}
    </div>
  );
};

export default YouTubePreview;
